<template>
  <header class="header">
    <Nav></Nav>
    <div class="content">
      <h3>快速响应服务每一个项目</h3>
      <p>快速启动 &nbsp; | &nbsp; 快速开发 &nbsp; | &nbsp; 轻松运营</p>
    </div>
  </header>
  <div class="services">
    <h3>我们的服务</h3>
    <p>以专业服务的态度，提供最具针对性的APP开发服务</p>
    <div class="content">
      <div class="dzapp" @mouseenter="mouseOver(1)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 1"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yddz.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yidong.png" alt="" />
        <h5>移动APP定制</h5>
        <p>IOS Android原生、混合开发、协助上架100%源码交付、免费服务...</p>
      </div>
      <div class="dsping" @mouseenter="mouseOver(2)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 2"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dspt.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dspt01.png" alt="" />
        <h5>电商平台建设</h5>
        <p>
          社交电商\零售解决方案致力于为自媒体、零售企业提供微信社交电商解决方案...
        </p>
      </div>
      <div class="rjdz" @mouseenter="mouseOver(3)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 3"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hyrjdz01.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hyrj.png" alt="" />
        <h5>行业软件定制开发</h5>
        <p>
          一对一服务，ERP系统、SCRM系统、OA管理系统、工程管理系统、项目管理...
        </p>
      </div>
      <div class="wxgzh" @mouseenter="mouseOver(4)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 4"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wxgzh01.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wxgzh.png" alt="" />
        <h5>微信公众号/小程序定制开发</h5>
        <p>
          社交、交通出行、直播电商、预约、短视频运营、生活服务、招聘、海外仓管理...
        </p>
      </div>
      <div class="wzxt" @mouseenter="mouseOver(5)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 5"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wzyddz01.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wzdz.png" alt="" />
        <h5>网站系统定制</h5>
        <p>
          Web管理系统，网络营销系统等，迎合互联网发展趋势，全程一对一配套服务...
        </p>
      </div>
      <div class="wlyy" @mouseenter="mouseOver(6)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 6"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wlyy01.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wlyy.png" alt="" />
        <h5>网络运营</h5>
        <p>快速搭建直播/点播平台，统一数据独立展现，全渠道覆盖消费者...</p>
      </div>
      <div class="wlw" @mouseenter="mouseOver(7)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 7"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wlw01.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/wlw.png" alt="" />
        <h5>物联网+</h5>
        <p>针对企业需求，提供专业智能物联网开发服务，让智能物联更简单...</p>
      </div>
      <div class="qiye" @mouseenter="mouseOver(8)" @mouseleave="mouseLeave">
        <img
          v-if="isLogoShow && index == 8"
          src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/qyzf01.png"
          alt=""
        />
        <img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/qyzfh.png" alt="" />
        <h5>企业/政府信息化</h5>
        <p>
          提高企业/政府管理效率，针对不同需求制定配套解决方案，分析问题、解决问题...
        </p>
      </div>
    </div>
  </div>
  <div class="software">
    <h3>移动软件定制开发</h3>
    <p>
      众多知名企业的放心之选，以专业的技术，成熟的行业经验，为企业提供高效可靠的移动化服务
    </p>
    <div class="content">
      <div
        @mouseenter="red(1)"
        :class="{
          red1: redStatus && redindex == 1,
        }"
      >
        <h5>可视化开发、生成专业级源代码 适配对端应用</h5>
        <p>
          通过可视化拖拉拽快递构建应用程序，一键生成专业及应用代码，开发者可直接二次开发使用
        </p>
        <!-- <button>了解详情 ></button> -->
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/rng.png" alt="" />
      </div>
      <div
        @mouseenter="red(2)"
        :class="{
          red2: redStatus && redindex == 2,
        }"
      >
        <h5>一套代码，适配多端应用</h5>
        <p>
          只需一次作业，使用HTML5技术同时发布为Android、IOS、小程序、HTML5多端应用，使企业更专注于业务创新
        </p>
        <!-- <button>了解详情 ></button> -->
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jiashuyunyong.png" alt="" />
      </div>
      <div
        @mouseenter="red(3)"
        :class="{
          red3: redStatus && redindex == 3,
        }"
      >
        <h5>可加速应用开发、极致性体验</h5>
        <p>
          强大的Native渲染引擎提供丰富的API。出色的原生性和流畅的页面交互，为您的用户提供最佳的使用体验
        </p>
        <!-- <button>了解详情 ></button> -->
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yitaodaima.png" alt="" />
      </div>
    </div>
  </div>
  <div class="chuangye">
    <h3>移动互联网创业-企业数字化转型</h3>
    <p>
      众多知名企业的放心之选，以专业的技术，成熟的行业经验，为企业提供高效可靠的移动化服务
    </p>
    <div class="content">
      <div
        @mouseenter="zhankai(1)"
        class="yykf"
        :class="{
          zhankai: zhankaiStatus && index1 == 1,
          zkyykf: zhankaiStatus && index1 == 1,
        }"
      >
        <h5>应用开发</h5>
        <p></p>
      </div>
      <div
        class="kshykf"
        @mouseenter="zhankai(2)"
        :class="{
          zhankai: zhankaiStatus && index1 == 2,
          zkkshykf: zhankaiStatus && index1 == 2,
        }"
      >
        <h5>可视化云开发</h5>
        <p></p>
      </div>
      <div
        class="yycs"
        @mouseenter="zhankai(3)"
        :class="{
          zhankai: zhankaiStatus && index1 == 3,
          zkyycs: zhankaiStatus && index1 == 3,
        }"
      >
        <h5>应用测试</h5>
        <p></p>
      </div>
      <div
        class="yyfb"
        @mouseenter="zhankai(4)"
        :class="{
          zhankai: zhankaiStatus && index1 == 4,
          zkyyfb: zhankaiStatus && index1 == 4,
        }"
      >
        <h5>应用发布</h5>
        <p></p>
      </div>
      <div
        class="yyyy"
        @mouseenter="zhankai(5)"
        :class="{
          zhankai: zhankaiStatus && index1 == 5,
          zkyyyy: zhankaiStatus && index1 == 5,
        }"
      >
        <h5>应用运营</h5>
        <p></p>
      </div>
    </div>
  </div>
  <div class="flow">
    <h3>开发流程</h3>
    <p>标准规范化开发流程，为项目质量提供有力保障</p>
    <div class="content">
      <div class="xian"></div>
      <div>
        <div class="box">
          <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/search.png" alt="" />
        </div>
        <p>收集需求、定位分析、可行性分析、制定配套方案</p>
      </div>
      <div>
        <div class="box">
          <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/quan.png" alt="" />
        </div>
        <p>功能策划、风格设计、内容规划、客户沟通、合同签订</p>
      </div>
      <div>
        <div class="box">
          <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/rilibiao.png" alt="" />
        </div>
        <p>项目启动、专项小组流程分析 原型图制作、确定工期</p>
      </div>
      <div>
        <div class="box">
          <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hongfangkuang.png" alt="" />
        </div>
        <p>创意设计、页面设计、用户体验、研究分析</p>
      </div>
    </div>
    <div class="card">
      <div class="cardindex">
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hqwh.png" alt="" />
        <h5>后期维护</h5>
        <p>安全维护技术支持</p>
      </div>
      <div class="cardindex">
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xsys.png" alt="" />
        <h5>验收上线</h5>
        <p>验收合格 运营上线</p>
      </div>
      <div class="cardindex">
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jccs.png" alt="" />
        <h5>集成测试</h5>
        <p>验收测试 客户反馈</p>
      </div>
      <div class="cardindex">
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/cxkf.png" alt="" />
        <h5>程序开发</h5>
        <p>系统涉及 多平台开发</p>
      </div>
    </div>
  </div>
  <div class="customization">
    <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/imgleft.png" alt="" class="left" />
    <div class="right">
      <h5>APP开发定制服务</h5>
      <ul>
        <li>
          · 众多知名企业的放心之选，以专业的技术、成熟的行业经验 <br />
          &nbsp; 为企业提供高效可靠的移动化服务
        </li>
        <li>
          · 15年移动开发经验，自有平台技术支持App/小程序同时开发，升级成本低
        </li>
        <li>
          · 支持移动应用定制，小程序开发，业务系统开发，行业解决方案等，<br />
          &nbsp; 推动企业的创新发展与数字化升级
        </li>
      </ul>
     <!-- <button @click="toConsult">免费APP开发评估</button> -->
	  <a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">免费APP开发评估</a>
    </div>
  </div>
  <div class="example">
    <div class="content">
      <div class="left">
        <h5>各行业场景化案例</h5>
        <p>
          君和数字创意帮助用户在移动场景中快速落地，涵盖电商、新能源、教育、社交、金融、资讯、医疗等众多领域
        </p>
       <!-- <a href="#">更多行业案例 &nbsp; ></a> -->
      </div>
      <div class="right">
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/anli1.png" alt="" />
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/anli2.png" alt="" />
        <img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/anli33.png" alt="" />
      </div>
    </div>
  </div>
  <div class="apply">
    <h3>更多行业案例，快速构建企业级应用</h3>
    <p>更多行业案例，快速构建企业级应用</p>
   <!-- <button @click="toConsult">免费评估</button> -->
	<a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">免费评估</a>
  </div>
  <Footer></Footer>
  <Floating></Floating>
  <Onlineservice></Onlineservice>
</template>

<script>
import Nav from "./Nav.vue";
import Footer from "./Footer.vue";
import Floating from "./Floating.vue";
import Onlineservice from "./Onlineservice.vue";
export default {
  name: "Serve",
  components: {
    Nav,
    Footer,
    Floating,
    Onlineservice,
  },
  data() {
    return {
      isLogoShow: false,
      zhankaiStatus: true,
      redStatus: true,
      index1: 1,
      redindex: 2,
    };
  },
  methods: {
    // toConsult() {
    //   window.open(
    //     "https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
    //     "_blank"
    //   );
    // },
    mouseOver(index) {
      this.isLogoShow = true;
      this.index = index;
    },
    mouseLeave() {
      this.isLogoShow = false;
    },
    zhankai(i) {
      setTimeout(() => {
        this.index1 = i;
        console.log(this.index1);
        this.zhankaiStatus = true;
      }, 0.5);
    },
    red(i) {
      this.redindex = i;
      this.redStatus = true;
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 520px;
  background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/servebackground.png) no-repeat;
  background-size: cover;
  .content {
    width: 1440px;
    height: 400px;
    margin: 0 auto;
    /* background-color: white; */
    overflow: hidden;
    color: white;

    h3 {
      height: 50px;
      line-height: 50px;
      font-size: 36px;
      margin-top: 100px;
      font-weight: 540;
    }
    p {
      height: 50px;
      line-height: 50px;
      font-size: 22px;
      margin-top: 20px;
      font-weight: 400;
    }
  }
}
.services {
  width: 100%;
  height: 1080px;
  background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/fwxmbg.png) no-repeat;
  background-size: cover;
  overflow: hidden;
  h3 {
    height: 100px;
    margin: 0 auto;
    line-height: 100px;
    font-size: 36px;
    text-align: center;
    font-weight: 500;
    margin-top: 80px;
  }
  p {
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    font-size: 16px;
    text-align: center;
    font-weight: 400;
  }
  .content {
    width: 1440px;
    height: 820px;
    // background-color: red;
    margin: 0 auto;
    position: relative;
    div {
      margin-top: 60px;
      position: absolute;
      width: 406px;
      height: 210px;
      background: #ffffff;
      box-shadow: 1px 5px 20px 4px rgba(207, 214, 226, 0.3),
        0px 2px 0px 0px #ffffff;
      border-radius: 5px;
      overflow: hidden;
      img {
        display: block;
        width: 45px;
        height: 45px;
        margin-top: 40px;
        margin-left: 40px;
      }
      h5 {
        height: 30px;
        font-size: 24px;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
        margin: 20px 0 10px 40px;
      }
      p {
        width: 325px;
        height: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        text-align: left;
        margin-left: 40px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    div:hover {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/redbg.png) no-repeat;
      background-size: cover;
      h5 {
        color: #ffffff;
      }
      p {
        color: #ffffff;
      }
    }
    .dzapp {
      left: 20px;
    }
    .dsping {
      left: 0;
      right: 0;
      margin: 0 auto;
      top: 150px;
    }
    .rjdz {
      right: 20px;
    }
    .wxgzh {
      top: 240px;
    }
    .wzxt {
      top: 480px;
      left: 20px;
    }
    .wlyy {
      left: 0;
      right: 0;
      margin: 0 auto;
      top: 390px;
    }
    .wlw {
      right: 0px;
      top: 240px;
    }
    .qiye {
      right: 20px;
      top: 480px;
    }
  }
}
.software {
  width: 100%;
  height: 960px;
  background-color: #f4f4f8;
  overflow: hidden;
  h3 {
    height: 100px;
    margin: 0 auto;
    line-height: 100px;
    font-size: 36px;
    text-align: center;
    font-weight: 500;
    margin-top: 60px;
  }
  p {
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    font-size: 16px;
    text-align: center;
    font-weight: 400;
    margin-bottom: 60px;
  }
  .content {
    width: 1440px;
    height: 650px;
    // background-color: red;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    div {
      position: relative;
      overflow: hidden;
      width: 470px;
      height: 650px;
      background-color: #ffffff;
      border-radius: 8px;
      h5 {
        width: 370px;
        height: 40px;
        font-size: 26px;
        font-weight: 500;
        color: #14161d;
        line-height: 40px;
        margin: 0 auto;
        margin-top: 50px;
      }
      p {
        width: 367px;
        height: 26px;
        font-size: 16px;
        font-weight: 400;
        color: #14161d;
        line-height: 26px;
        margin-top: 80px;
        text-align: left;
      }
      a {
        display: block;
        width: 122px;
        height: 50px;
        background: #f4f4f8;
        box-shadow: 0px 8px 26px 0px rgba(255, 255, 255, 0.19);
        border-radius: 25px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 50px;
        margin-top: 80px;
        margin-left: 54px;
		text-align: center;
		line-height: 50px;
      }
      img {
        display: block;
        width: 250px;
        height: 250px;
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }
    .red1 {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/honghua1.png) no-repeat;
      background-size: cover;
      box-shadow: 0px 8px 26px 0px rgba(252, 24, 24, 0.532);
      h5 {
        color: #ffffff;
      }
      p {
        color: #ffffff;
      }
      img {
        filter: opacity(0);
      }
      button {
        color: red;
        background-color: #ffffff;
        font-size: 18px;
      }
    }
    .red2 {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/honghua2.png) no-repeat;
      background-size: cover;
      box-shadow: 0px 8px 26px 0px rgba(252, 24, 24, 0.532);
      h5 {
        color: #ffffff;
      }
      p {
        color: #ffffff;
      }
      img {
        filter: opacity(0);
      }
      button {
        color: red;
        background-color: #ffffff;
        font-size: 18px;
      }
    }

    .red3 {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/honghua3.png) no-repeat;
      background-size: cover;
      box-shadow: 0px 8px 26px 0px rgba(252, 24, 24, 0.532);
      h5 {
        color: #ffffff;
      }
      p {
        color: #ffffff;
      }
      img {
        filter: opacity(0);
      }
      button {
        color: red;
        background-color: #ffffff;
        font-size: 18px;
      }
    }
  }
}
.chuangye {
  width: 100%;
  height: 960px;
  background-color: #ffffff;
  overflow: hidden;
  h3 {
    height: 100px;
    margin: 0 auto;
    line-height: 100px;
    font-size: 36px;
    text-align: center;
    font-weight: 500;
    margin-top: 60px;
  }
  p {
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    font-size: 16px;
    text-align: center;
    font-weight: 400;
    margin-bottom: 60px;
  }
  .content {
    width: 1440px;
    height: 650px;
    // background-color: red;
    margin: 0 auto;
    div {
      overflow: hidden;
      width: 150px;
      height: 540px;
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/kehykf01.png) no-repeat;
      transition: all 0.5s;

      margin: 0 5px;
      float: left;
      h5 {
        width: 96px;
        height: 60px;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        margin-left: 20px;
        margin-top: 20px;
      }
      p {
        opacity: 0;
        width: 40px;
        height: 4px;
        background: #fe0000;
        margin-top: 80px;
        margin-left: 20px;
      }
    }
    .yykf {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/kshykf.png) no-repeat;
      background-size: cover;
    }
    .zkyykf {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/kshykf01.png) no-repeat !important;
      background-size: cover;
    }
    .kshykf {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xxxx01.png) no-repeat;
      background-size: cover;
    }
    .zkkshykf {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xxxx02.png) no-repeat;
      background-size: cover;
    }
    .yycs {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yycs01.png) no-repeat;
      background-size: cover;
    }
    .zkyycs {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yycs02.png) no-repeat;
      background-size: cover;
    }
    .yyfb {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yyfb01.png) no-repeat;
      background-size: cover;
    }
    .zkyyfb {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yyfb02.png) no-repeat;
      background-size: cover;
    }
    .yyyy {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yyyy01.png) no-repeat;
      background-size: cover;
    }
    .zkyyyy {
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yyyy02.png) no-repeat;
      background-size: cover;
    }

    .zhankai {
      width: 770px !important;
      height: 540px !important;

      //   transition: width 0.5s;
      h5 {
        width: 146px;
        height: 34px;
        font-size: 36px;
        font-weight: 500;
        color: #ffffff;
        line-height: 48px;
      }
      p {
        opacity: 1;
      }
    }
  }
}
.flow {
  width: 100%;
  height: 670px;
  background: #f5f5f7;
  display: inline-block;
  position: relative;
  h3 {
    height: 100px;
    margin: 0 auto;
    line-height: 100px;
    font-size: 36px;
    text-align: center;
    font-weight: 500;
    margin-top: 60px;
  }
  p {
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    font-size: 16px;
    text-align: center;
    font-weight: 400;
  }
  .content {
    width: 1440px;
    height: 500px;
    // background: #999999;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .xian {
      width: 1045px;
      height: 1px;
      background: #ffffff;
      margin: 0 auto;
      position: absolute;
      top: 340px;
    }
    div {
      width: 306px;
      height: 350px;
      .box {
        width: 94px;
        height: 94px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        margin: 10px auto;
        img {
          position: relative;
          display: block;
          width: 44px;
          height: 44px;
          margin: auto;
          margin-top: 24px;
          z-index: 999;
        }
      }
      p {
        width: 223px;
        height: 43px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        margin: 50px auto;
      }
    }
  }
  .card {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    width: 1440px;
    height: 420px;
    left: 0;
    right: 0;
    margin: 0 auto;
    // background-color: red;
    bottom: -320px;
    .cardindex {
      width: 306px;
      height: 411px;
      background: #ffffff;
      box-shadow: 7px 11px 12px 0px rgba(232, 236, 242, 0.5),
        0px 2px 0px 0px #ffffff;
      border-radius: 5px;
      text-align: center;
      overflow: hidden;

      img {
        display: block;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        margin-top: 50px;
      }
      h5 {
        width: 100%;
        height: 30px;
        text-align: center;
        font-size: 26px;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
        margin-top: 80px;
      }
      p {
        width: 80px;
        height: 26px;
        line-height: 26px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        margin: 0 auto;
        margin-top: 10px;
      }
    }
  }
}
.customization {
  width: 1440px;
  height: 1080px;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  align-items: center;

  img {
    margin-top: 350px;
    display: block;
    width: 510px;
    height: 450px;
  }
  .right {
    margin-top: 350px;
    width: 560px;
    height: 650px;
    overflow: hidden;
    h5 {
      width: 560px;
      height: 39px;
      font-size: 40px;
      font-weight: 500;
      color: #000000;
      line-height: 30px;
      margin-top: 50px;
      margin-bottom: 20px;
    }
    ul > li {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 30px;
      margin-bottom: 30px;
    }
    a {
      margin-top: 20px;
      width: 180px;
      height: 50px;
      background: #fe0000;
      box-shadow: 0px 8px 32px 0px rgba(254, 0, 0, 0.16);
      border-radius: 25px;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
	  text-align: center;
	  padding: 10px;
    }
  }
}
.example {
  width: 100%;
  height: 825px;
  background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/anlibg.png) no-repeat;
  background-size: cover;
  .content {
    width: 1440px;
    height: 825px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .left {
      width: 450px;
      height: 600px;
      h5 {
        margin-top: 150px;
        margin-bottom: 30px;
        width: 400px;
        height: 38px;
        font-size: 40px;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
      }
      p {
        width: 406px;
        height: 46px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 30px;
      }
      a {
        display: block;
        margin-top: 150px;
        width: 150px;
        height: 16px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
      }
    }
    .right {
      width: 950px;
      height: 600px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        display: block;
        width: 288px;
        height: 600px;
      }
    }
  }
}
.apply {
  width: 100%;
  height: 386px;
  background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yingyongbg.png) no-repeat;
  background-size: cover;
  overflow: hidden;
  h3 {
    width: 100%;
    height: 37px;
    font-size: 36px;
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    margin-top: 97px;
  }
  p {
    width: 342px;
    height: 18px;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
  }
  a {
    display: block;
    width: 210px;
    height: 60px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 10px 17px 20px 0px rgba(255, 255, 255, 0.1),
      0px 1px 0px 0px #ffffff;
    border-radius: 30px;
    margin: 0 auto;
    margin-top: 90px;
    font-size: 18px;
    font-weight: 500;
    color: #00003e;
	text-align: center;
	line-height: 60px;
  }
}
</style>